/*jshint esversion: 6 */
import store from '@/store/index';

function Template(payload) {
  let route = {
    path: ':template_type/:workpackage_id',
    name: payload.name?payload.name:'TaktPlanAddWorkPackageDetails',
    component: () => import( 
       
      '@/views/Project/TaktPlanWorkPackage/TaktPlanWorkPackageAddDetails.view.vue'),
    props: (route) => {
      let prefix = '';
      switch (route.params.template_type) {
        case 'custom':
          break;
        case 'company':
          prefix = 'b';
          break;
        case 'community':
          prefix = 'c';
          break;
      }
      return {
        prefix: prefix,
        project_id: parseInt(route.params.project_id),
        train_id: parseInt(route.params.train_id),
        taktarea_id: parseInt(route.params.taktarea_id),
        twaggon_id: parseInt(route.params.twaggon_id),
        work_package:
          store.getters['WorkBench/getWBObject']({
          type: `${prefix}workpackages`,
          id: route.params.workpackage_id
        }),
        backlog: payload.backlog?true:false,
      };
    },
    meta: {
      requiresAuth: true
    },
  };
  if (payload && payload.children) {
    route.children = payload.children;
  }
  return route;
}
export default Template;
